import { ApiEndpointClient } from './resource-client';
const BACKEND_FOR_FRONTEND_PREFIX = 'valuation-frontend';
export class TextSnippetsClient extends ApiEndpointClient {
    constructor(http) {
        super(http, BACKEND_FOR_FRONTEND_PREFIX);
    }
    getTextSnippets = async (options) => {
        return this.get('/text-snippets/', { response: 'content-type-or-empty', signal: options?.signal });
    };
}
